// @flow

import React from "react";

const SECONDS_PER_DAY = 86400;

export type Props = $Exact<{
  id: string,
  name: string,
  value: number,
  required: boolean,
  options: Object,
  schema: Object,
  disabled: boolean,
  readonly: boolean,
  onChange: (value: number) => {},
}>;

export function SecondsAsDaysInput(props: Props) {
  const { value, options, schema } = props;

  function toDays(seconds: number) {
    return isNaN(seconds) ? 0 : Math.round((seconds / SECONDS_PER_DAY) * 10) / 10;
  }

  function toSeconds(hours: number) {
    return hours * SECONDS_PER_DAY;
  }

  function handleChange(event: SyntheticEvent<HTMLInputElement>) {
    props.onChange(
      !isNaN(event.currentTarget.value) ? toSeconds(+event.currentTarget.value) : props.value,
    );
  }

  return (
    <div className="schema-form-widget-seconds-as-days-input position-relative">
      <input
        type="number"
        id={props.id}
        name={props.name}
        className="form-control"
        value={toDays(value)}
        required={props.required}
        onChange={handleChange}
        disabled={props.disabled}
        readOnly={props.readonly}
        min={schema.minimum}
        max={schema.maximum}
        placeholder="# days"
      />
      <label htmlFor={props.id} className="position-absolute top-10 right-25">
        days
      </label>
    </div>
  );
}

export default SecondsAsDaysInput;
